import React from 'react';
import { Link } from 'react-router-dom';

import './Link.scss';

// Link without decoration, for wrapping components
export default ({children, ...props}) => <Link styleName="link" {...props}>{children}</Link>;